<template>
  <!-- 该组件同步popshow 和地址id 返回地址信息name -->
  <div class="com_cascader">
    <van-popup v-model="showPopArea" round position="bottom" :safe-area-inset-bottom="true" :close-on-click-overlay="false" @click-overlay="onUpdateShow">
      <van-cascader v-model="addressId" :field-names="fieldNames" title="请选择所在地区" :options="options" @close="onUpdateShow" @change="onSelectItem" @finish="onFinish" />
    </van-popup>
  </div>
</template>

<script>
import {
  GetProList,
  GetDisList,
  GetTownList,
} from "@/pages/page1/api/modules/common";
import { popup, Cascader } from "vant";
export default {
  props: {
    level: {
      type: Number,
      default: 4,
    },
    showPopArea: {
      type: Boolean,
      default: false,
    },
    propAddressId: {
      type: String,
      default: "",
    },
  },
  components: {
    [popup.name]: popup,
    [Cascader.name]: Cascader,
  },
  data() {
    return {
      options: [],
      fieldNames: {
        text: "name",
        value: "code",
        children: "children",
      },
    };
  },
  mounted() {
    this.getProAndCityList();
  },
  computed: {
    addressId: {
      get: function () {
        return this.propAddressId;
      },
      set: function (v) {
        // console.log("v", v);
        this.$emit("update:propAddressId", v); // sync同步prop属性
      },
    },
  },
  methods: {
    // 地区处理 内部v-model会改变 导致props改变的报错 改为计算属性
    onSelectItem({ value, selectedOptions, tabIndex }) {
      // 选中城市 获取区县
      if (tabIndex == 1 && (this.level === 3 || this.level === 4)) {
        this.getDisList(value);
      }
      // 选中区县 获取街道
      if (tabIndex == 2 && this.level === 4) {
        this.getTownList(value);
      }
    },
    // 没有 children 时触发
    onFinish({ selectedOptions }) {
      // console.log(selectedOptions);
      let cascaderText = "";
      selectedOptions.forEach((v, i) => {
        cascaderText += v.name;
      });
      this.onUpdateShow();
      this.$emit("finish", cascaderText);
    },
    // sync同步prop属性
    onUpdateShow() {
      this.$emit("update:showPopArea", false);
    },
    // 省市
    getProAndCityList() {
      GetProList({}).then((res) => {
        // console.log("获取省市数据", res);
        if (this.level === 2) {
          this.options = res.data;
        }
        if (this.level === 3 || this.level === 4) {
          this.options = this.addChildren(res.data);
        }
        // console.log("数据一二层", this.options);
      });
    },
    // 区县
    getDisList(code) {
      GetDisList({ cityCode: code }).then((res) => {
        // console.log("获取区县数据", res);
        this.options.forEach((item) => {
          item.children.forEach((v) => {
            if (v.code === code) {
              if (this.level === 3) {
                v.children = res.data;
              }
              if (this.level === 4) {
                v.children = this.addChildren(res.data);
              }
            }
          });
        });
        // console.log("数据第三层", this.options);
      });
    },
    // 街道
    getTownList(code) {
      GetTownList({ districtCode: code }).then((res) => {
        // console.log("获取街道数据", res);
        this.options.forEach((item) => {
          item.children.forEach((v) => {
            v.children.forEach((j) => {
              if (j.code === code) {
                j.children = this.repliceTownKey(res.data);
              }
            });
          });
        });
        // console.log("数据第四层", this.options);
      });
    },
    // 数据处理 下一层children准备
    addChildren(arr) {
      arr.forEach((item) => {
        item.children = item.children || [];
        if (item.children.length > 0) {
          this.addChildren(item.children);
        }
      });
      return arr;
    },
    // 街道数据处理
    repliceTownKey(arr) {
      arr.forEach((item) => {
        item.code = item.id;
      });
      return arr;
    },
  },
};
</script>

<style lang="less" scoped>
.com_cascader {
  color: #333333;
}
</style>